var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvanzado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5Z",
    fill: "#E2E9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8657 5.33602C11.9554 5.30986 12.0507 5.30987 12.1403 5.33606L18.015 7.05218C18.2239 7.1132 18.3675 7.30472 18.3675 7.52233V11.0417C18.3675 14.9516 15.8653 18.4228 12.1558 19.6588C12.0553 19.6923 11.9467 19.6923 11.8462 19.6588C8.1358 18.4229 5.63281 14.9509 5.63281 11.0401V7.52233C5.63281 7.30467 5.77645 7.11312 5.98539 7.05215L11.8657 5.33602ZM15.6118 10.724C15.8031 10.5327 15.8031 10.2226 15.6118 10.0313C15.4205 9.84 15.1104 9.84 14.9191 10.0313L11.3471 13.6033L9.40771 11.6639C9.21643 11.4727 8.90631 11.4727 8.71503 11.6639C8.52375 11.8552 8.52375 12.1653 8.71503 12.3566L11.0007 14.6423C11.192 14.8336 11.5021 14.8336 11.6934 14.6423L15.6118 10.724Z",
    fill: "#35435D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvanzado);
export default __webpack_public_path__ + "static/media/avanzado.dc7792edf7aed4bff2505933988d3941.svg";
export { ForwardRef as ReactComponent };